<template>
  <div>
    <v-dialog v-model="loading" persistent width="600">
      <v-card color="primary" dark>
        <v-card-text>
          Proccessing
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout wrap row justify-start pa-2 py-5>
      <v-flex xs4 px-2>
        <v-card :loading="loading" class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Log
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <!-- <v-flex xs6 pa-1>
                <v-menu v-model="fsd" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                  offset-y full-width min-width="290px">
                  <template slot="activator">
                    <v-text-field v-model="fTLDate" label="From Status Date" append-icon="event" readonly hide-details
                      clearable solo :loading="loading"></v-text-field>
                  </template>
                  <v-date-picker v-model="fTLDate" @input="fsd = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu v-model="tsd" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                  offset-y full-width min-width="290px">
                  <template slot="activator">
                    <v-text-field v-model="tTLDate" label="To Status Date" append-icon="event" readonly hide-details
                      clearable solo :loading="loading"></v-text-field>
                  </template>
                  <v-date-picker v-model="tTLDate" @input="tsd = false"></v-date-picker>
                </v-menu>
              </v-flex> -->
              <v-flex xs6 pa-1>
                <v-select hide-details :items="warehouses" solo :loading="loading" item-value="name"
                  v-model="selectedWarehouse" label="Warehouse" item-text="name" clearable></v-select>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-text-field label="SKU" solo :loading="loading" v-model="selectedSKU"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="() => {
              LoadByFilter()
            }">SYNC by SKU & WH</v-btn>
            <v-btn color="primary" @click="() => {
              LoadByWH()
            }">SYNC by WH</v-btn>
            <v-btn color="primary" :disabled="syncallloading" :loading="syncallloading" @click="() => {
              syncAll()
            }">SYNC ALL</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs8 px-2>
        <v-card :loading="loading" class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Log
            <v-spacer></v-spacer>
            
          </v-card-title>
          <v-card-text>
            <v-layout row wrap style="height:800px;overflow-y:scroll;background:#efefef;" id="scroller">
              <v-flex xs12 v-for="(l, i) in log" :key="i + 'log'" mb-1 mx-2 mt-1>
                <v-card class="elevation-2 pa-2" :loading="loading">
                  <v-layout row wrap>
                    <v-flex xs2 class="text-xs-center" v-for="(key, k) in Object.keys(l)" :key="'ll-'+k">
                      <div style="font-weight:bold;">{{ key }}</div>
                      <div>{{ l[key] }}</div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate } from '@/customFunction';
import axios from 'axios';
import json2csv from 'json2csv'
const headers = {
  'Accept': 'application/json'
}

export default {
  data() {
    return {
      menu2: false,
      time: null,
      menu4: false,
      time2: null,
      loading: false,
      pastedData: null,
      spastedData: null,
      delimiter: ',',
      nKeys: null,
      shippingStatus: [],
      warehouses: [],
      selectedWarehouse: null,
      fsd: null,
      selectedSKU: null,
      fTLDate: null,
      tsd: null,
      tTLDate: null,
      warehouses: [],
      products: [],
      last: null,
      log: [],
      exports: [],
      selectedTransactions: [],
      selectedGroupTransactions: [],
      syncallloading:false,
    }
  },
  methods: {
    async getShippingStatuses() {
      let a = await db.ref('shippingstatuses').once('value').then(x => x.val())
      this.shippingStatus = Object.values(a).map(x => x.name)
    },
    async getWarehouses() {
      this.loading = true
      this.warehouses = await store.collection('warehouses').get().then(x => x.docs.map(y => {
        return {
          ...y.data(),
          key: y.id
        }
      }).filter(x => !x.lock))

      this.loading = false
    },
    async getProducts() {
      this.loading = true
      this.products = await store.collection('products').get()
        .then(x => x.docs.map(y => {
          return {
            ...y.data(),
            warehouses: y.data().warehouses ? y.data().warehouses : []
          }
        }))
      this.loading = false
    },
    clipboardSuccessHandler({ value, event }) {
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async LoadByFilter() {
      return this.loopSync(this.selectedWarehouse, this.selectedSKU)
      
    },
    
    async loopSync(wh, sku) {
      return new Promise(async (res, rej) => {
        if(!wh || !sku) {
          this.log.push({skipped: wh + ' ' + sku})
          return res(true)
        }
        let a = await store.collection(`warehouseactions`)
          .where("warehouse_name", "==", wh)
          .where("product_sku", "==", sku).get().then(x => x.docs.map((y, i) => {
            if (i == x.docs.length - 1) this.last = y
            return { ...y.data(), key: y.id }
          }))
        console.log('logs', a)
        if(!a.length) {
          this.log.push({ skipped: wh + ' ' + sku })
          return res(true)
        }
        let none = a.filter(x=> x.status !== 'reserved').filter(t => t.transaction == 'none');
        let subtract = a.filter(x=> x.status !== 'reserved').filter(t => t.transaction == 'subtract');
        let add = a.filter(x=> x.status !== 'reserved').filter(t => t.transaction == 'add');
        let subtract_sum = subtract.reduce((accumulator, current) => {
          return accumulator + parseInt(current.quantity);
        }, 0);
        let add_sum = add.reduce((accumulator, current) => {
          return accumulator + parseInt(current.quantity);
        }, 0);

        let product_search = await store.collection('products')
          .where("sku", "==", sku)
          .get()
          .then(x => x.docs.map(y => {
            return {
              ...y.data(),
              warehouses: y.data().warehouses ? y.data().warehouses : []
            }
          }))
        let product = product_search[0]
        let product_whs = product.warehouses
        let selected_product_wh = product_whs.filter(x=>x.warehouse == wh)[0]
        console.log('subtract_sum', subtract_sum)
        console.log('add_sum', add_sum)
        console.log('product', product)
        console.log('product', selected_product_wh)

        if(!selected_product_wh) { //  || !selected_product_wh.quantity
          this.log.push({ skipped: wh + ' ' + sku })
          return res(true)
        }

        let current_count = parseInt(selected_product_wh.quantity)
        let update_count = add_sum - subtract_sum
        let difference = current_count - update_count
        var sfDocRef = store.collection("products").doc(product.key);
        let log = {
          sku,
          wh,
          current_count,
          subtract_sum,
          add_sum,
          difference,
          update_count,
        }
        this.log.push(log)
        if(difference !== 0) {

          try {
            await store.runTransaction(function (transaction) {
              // This code may get re-run multiple times if there are conflicts.
              return transaction.get(sfDocRef).then(function (sfDoc) {
                if (!sfDoc.exists) {
                  throw "Document does not exist!";
                }
                // Add one person to the city population.
                // Note: this could be done without a transaction
                //       by updating the population using FieldValue.increment()
                var product = sfDoc.data()
                product.warehouses.filter(x => x.warehouse == wh)[0].quantity = parseInt(update_count);
                transaction.update(sfDocRef, product);
              });
            })
          } catch (error) {
            this.log.filter(x=>x.sku == sku &&x.wh == wh)[0].error = true
          }
          this.log.filter(x=>x.sku == sku &&x.wh == wh)[0].updated = true
          let wh_log = {
            product_sku: product.sku.trim(),
            product_key: product.key,
            user: "SYSTEM",
            date: getCDate(),
            status: 'EDIT',
            transaction_timestamp: new Date().getTime(),
            transaction_id: randomString(8, '#Aa'),
            status_date: getCDate(),
            timestamp: new Date(getCDate()).getTime(),
            quantity: update_count,
            transaction: 'none',
            warehouse_name: wh,
            warehouseh_key: this.warehouses.filter(x => x.name == wh)[0].key,
            order_key: 0,
            document_number: 0
          }
          console.log(wh_log)
          try {
            await store.collection('warehouseactions').add(wh_log)
          } catch (error) {
            this.log.filter(x=>x.sku == sku &&x.wh == wh)[0].error = true
          }
          this.log.filter(x => x.sku == sku && x.wh == wh)[0].logged = true
        }
        res(true)
      })
    },
    async LoadByWH() {
      this.log.push({ started: true })
      let products = this.products
      for (let j = 0; j < products.length; j++) {
        const product = products[j];
        await this.loopSync(this.selectedWarehouse, product.sku)
      }
    },
    async syncAll() {
      this.syncallloading = true
      this.log.push({started:true})
      let whs = this.warehouses.filter(x=>!x.lock)
      let products = this.products
      for (let i = 0; i < whs.length; i++) {
        const wh = whs[i];
        for (let j = 0; j < products.length; j++) {
          const product = products[j];
          await this.loopSync(wh.name, product.sku)
        }
      }
      this.syncallloading = true
    },
    async init(){
      this.getShippingStatuses()
      this.getProducts()
      this.getWarehouses()
    }
    
  },
  props: {
    superAdmin: {
      required: true
    },
  },
  computed: {

  },
  async created() {

    this.init()









  },
  mounted() {
  }
}
</script>

<style>
.tokenField * {
  color: white !important;
}
</style>
